module.exports = __webpack_public_path__ + "png/wheel-arrow.png?ee4d1d7581505e04285891edf808324e";